/* QualGear — bulk order by family: progressive enhancement only.
   The form works without this file (native multi-item POST to /cart/add). With it:
   +/- steppers, a live "N items selected / units / total" line, and a guard that stops
   an empty submit. The section is re-rendered by facets.js, so init is delegated. */
(function () {
  if (window.qgBulkFamilyInit) return;
  window.qgBulkFamilyInit = true;

  function money(cents, currency) {
    var value = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency }).format(value);
    } catch (e) {
      return value.toFixed(2);
    }
  }

  function enhance(form) {
    if (form.dataset.qgBulkReady) return;
    form.dataset.qgBulkReady = 'true';
    var summary = form.querySelector('[data-bulk-summary]');
    var inputs = Array.prototype.slice.call(form.querySelectorAll('.qg-bulk-family__input'));

    inputs.forEach(function (input) {
      var wrap = input.parentNode;
      var name = wrap.getAttribute('data-stepper-product') || '';
      var dec = document.createElement('button');
      var inc = document.createElement('button');
      [dec, inc].forEach(function (b) {
        b.type = 'button';
        b.className = 'qg-bulk-family__step';
      });
      dec.dataset.step = '-1';
      inc.dataset.step = '1';
      dec.textContent = '−';
      inc.textContent = '+';
      dec.setAttribute('aria-label', (form.dataset.dec || '').replace('__P__', name));
      inc.setAttribute('aria-label', (form.dataset.inc || '').replace('__P__', name));
      wrap.insertBefore(dec, input);
      wrap.appendChild(inc);
    });

    function step(input, dir) {
      var inc = parseInt(input.step, 10) || 1;
      var min = parseInt(input.dataset.qtyMin, 10) || 1;
      var cur = parseInt(input.value, 10) || 0;
      var next;
      if (dir > 0) next = cur === 0 ? Math.max(min, inc) : cur + inc;
      else next = cur - inc < min ? 0 : cur - inc;
      var max = parseInt(input.getAttribute('max'), 10);
      if (max && next > max) next = max;
      if (next < 0) next = 0;
      input.value = next;
      update();
    }

    function update() {
      if (!summary) return;
      var lines = 0, units = 0, cents = 0;
      inputs.forEach(function (input) {
        var q = parseInt(input.value, 10) || 0;
        if (q > 0) {
          lines += 1;
          units += q;
          cents += q * (parseInt(input.dataset.price, 10) || 0);
          input.closest('tr').classList.add('is-selected');
        } else {
          input.closest('tr').classList.remove('is-selected');
        }
      });
      var d = summary.dataset;
      if (!lines) { summary.textContent = d.none; return; }
      var count = lines === 1 ? d.one : d.other.replace(/\b2\b/, lines);
      summary.textContent = count + ' · ' + (units === 1 ? d.unitsOne : d.unitsOther.replace(/\b2\b/, units)) + ' · ' + d.total.replace('__T__', money(cents, form.dataset.currency));
    }

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('.qg-bulk-family__step');
      if (!btn) return;
      var input = btn.parentNode.querySelector('.qg-bulk-family__input');
      step(input, btn.dataset.step === '-1' ? -1 : 1);
    });
    form.addEventListener('input', update);
    form.addEventListener('change', update);

    form.addEventListener('submit', function (e) {
      var any = inputs.some(function (i) { return (parseInt(i.value, 10) || 0) > 0; });
      if (any) {
        // Zero-quantity rows would make /cart/add reject the whole batch: drop them from the POST.
        inputs.forEach(function (i) {
          if (!(parseInt(i.value, 10) || 0)) {
            i.disabled = true;
            var hid = i.closest('td').querySelector('input[type="hidden"]');
            if (hid) hid.disabled = true;
          }
        });
        return;
      }
      e.preventDefault();
      if (summary) {
        summary.textContent = summary.dataset.pick;
        var first = inputs[0];
        if (first) first.focus();
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-qg-bulk-form]').forEach(enhance);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // facets.js re-renders the section's innerHTML on filter changes.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; init(); });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  // Back/forward cache restores the page with the zero-quantity rows still disabled.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-qg-bulk-form] :disabled').forEach(function (el) { el.disabled = false; });
  });
})();
